const TiposPendencia = {
      documentos: 1,
      dadosCadastrais: 2
}

export default TiposPendencia;